/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Protocollink1Inputs */

const de__field_protocollink1 = /** @type {(inputs: _Field_Protocollink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protokolllink`)
};

/**

* @param {_Field_Protocollink1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_protocollink1 = /** @type {((inputs?: _Field_Protocollink1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Protocollink1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_protocollink1(inputs)
});
export { _field_protocollink1 as "_field_protocolLink" }